module.exports = __webpack_public_path__ + "img/multiply_blue.6979c9ba.png";